module.exports = __webpack_public_path__ + "media/src/images/icons/notice/blue-a341880d932cf2cb56344fdbbe4ffb3e.svg";